<template>
  <ContentWrap title="景区管理">
    <el-alert
      type="info"
      :closable="false"
      show-icon
      class="mb-16px"
      title="仅展示绑定到当前商家名下的景区，景点与票档配置请联系平台运营在景区后台维护。"
    />
    <el-table v-loading="loading" :data="list" border>
      <el-table-column prop="id" label="ID" width="80" align="center" />
      <el-table-column prop="spotCode" label="景区编码" width="140" align="center" />
      <el-table-column prop="spotName" label="景区名称" min-width="180" show-overflow-tooltip />
      <el-table-column prop="city" label="城市" width="120" align="center" />
      <el-table-column label="状态" width="100" align="center">
        <template #default="{ row }">
          <el-tag :type="row.status === 1 ? 'success' : 'info'">
            {{ row.status === 1 ? '已发布' : row.status === 0 ? '草稿' : '已下线' }}
          </el-tag>
        </template>
      </el-table-column>
    </el-table>
  </ContentWrap>
</template>

<script setup lang="ts">
import { onMounted, ref } from 'vue'
import { getScenicMerchantSpotList } from '@/api/merchant/scenic'

defineOptions({ name: 'MerchantScenicSpot' })

const loading = ref(false)
const list = ref<any[]>([])

onMounted(async () => {
  loading.value = true
  try {
    const data = await getScenicMerchantSpotList()
    list.value = Array.isArray(data) ? data : []
  } finally {
    loading.value = false
  }
})
</script>
